import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]

import {onBeforeMount, ref} from "vue"
  import {File as FileClient} from "@/endpoints/rutsolve/rest/file"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'image',
  props: {
    data: {
      default: null,
      required: false,
      type: String
    },
    extension: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    },
    url: {
      default: null,
      required: false,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const source = ref<string>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    if (props.url) {
      source.value = await FileClient.read(props.url)
    } else {
      source.value = `data:image/${props.extension};base64,${props.data}`
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (source.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: source.value,
            alt: __props.title
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: require('@/images/computerinfor_icon.png'),
            alt: __props.title
          }, null, 8, _hoisted_2))
    ]),
    _: 1
  }))
}
}

})